(function (angular, app) {
   "use strict";

   angular.module(app.modules.course.name)
      .controller(app.modules.course.routes.search.controller, GolfCourseSearchController);
      
   GolfCourseSearchController.$inject = ["$scope", "$q", "$window", "$timeout", "ngDialog"
      , app.modules.course.services.search
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.common.constants.appmessaging
      , app.modules.common.constants.appsettings
      , app.modules.common.constants.regionlist
      , app.modules.common.constants.countrylist
      , app.modules.ui.services.alerts
   ];
   
   function GolfCourseSearchController($scope, $q, $window, $timeout, ngDialog
      , ggCourseSearchSvc
      , ggFunctions
      , ggStorage
      , ggMessages
      , ggSettings
      , ggRegionList
      , ggCountryList
      , ggAlertSvc
   ){
      
      // Controller
      var ctrl = this;

      // Scopes
      $scope.Course = null;
      $scope.PopupAlert = new ggAlertSvc.popup;
      
      $scope.Temp = {
         isLoaded: true
         , isSwiper: false
         , window: ggFunctions.fetchWindowSize()
         , gender : ""
      }

      $scope.View = {
         tabs: {
            current: 2
            , types: {
               search: 1
               , follower: 2
               , location : 3 
            }
            , select : function(tab){
               if (!tab) {
                  tab = $scope.View.tabs.current;
               }

               $scope.View.tabs.current = tab;
               app.Member.Session.bookmark.course.tab = tab; // Remember selected tab
               $scope.f.scrollLimit.reset(); // Reset Scroll limit

               // MyCourses
               if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
                  $scope.Content.byFollower.fetch();
               }
               // GeoLocation
               if ($scope.View.tabs.current == $scope.View.tabs.types.location) {
                  $scope.Content.byLocation.fetch();
               }
            }
            , isActive: function (tab) {
               return tab == $scope.View.tabs.current;
            }
      
         }
      }

      $scope.Content = {
         init: function () {

             $scope.Temp.gender = app.Member.Detail.gender || "";

            var tab1 = app.Member.Session.bookmark.course.tab;
            $scope.View.tabs.select(tab1);
            ggFunctions.scrollToTop(0);

         }
         , bySearch: {
            results: []
            , isDirty: false
            , isSearch: false
            , reset: function () {
               $scope.Content.bySearch.isSearch = false;
               $scope.Content.bySearch.results = [];
            }
            , countrylist: {
               data: ggCountryList //app.data.Countries
            }
            , regionlist: {
               data: ggRegionList //app.data.Regions
            }
            , form: {
               name: ""
               , regioncode: ""
            }
            , fetch: function (isValid) {
               if (isValid) {
                  ggCourseSearchSvc.search.fetchCourseSearch($scope.Content.bySearch.form).then(function (data) {
                     if (data && data.status == "200"){
                        $scope.Content.bySearch.results = data.data.value;
                     }

                  }).finally(function(){
                     $scope.Content.bySearch.isSearch = true;
                  })
                  ;
               }
            }
            , swipe: {
               selected: 0
               , isFollowing : false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.bySearch.swipe.selected = id;
                  $scope.Content.bySearch.swipe.isFollowing = $scope.f.isMemberCourse(id);

               }
               , right: function (memberId) {
                  $scope.f.isSwiper();
                  $scope.Content.bySearch.swipe.selected = 0;
                  $scope.Content.bySearch.swipe.isFollowing = false;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.bySearch.swipe.selected
               }
            }
         }
         , byFollower: {
            results: []
            , isSearch: false
            , fetch: function (isRefresh) {
               var processData = function (results) {
                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.name;
                        var d2 = b.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.byFollower.results = results
                  $scope.Content.byFollower.isSearch = true;
                  //return $q.when();
               }


                  return app.Member.Network.Data.Courses.fetch(true).then(function (data) {
                     return processData(data);
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });

            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.byFollower.swipe.selected = id;
                  $scope.Content.byFollower.swipe.isFollowing = $scope.f.isMemberCourse(id);

               }
               , right: function (memberId) {
                  $scope.f.isSwiper();
                  $scope.Content.byFollower.swipe.selected = 0;
                  $scope.Content.byFollower.swipe.isFollowing = false;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.byFollower.swipe.selected
               }
            }
         }
         , byLocation: {
            results: []
            , isDirty : false
            , isSearch: false
            , fetch: function (isRefresh) {
               var processData = function (results) {
                  if (results.length > 0) {
                     // Sort on date
                     results.sort(function (a, b) {
                        var d1 = a.name;
                        var d2 = b.name;
                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                        return v;
                     });
                  }

                  $scope.Content.byLocation.results = results
                  $scope.Content.byLocation.isSearch = true;
                  //return $q.when();
               }


               // Current Location
               var location = app.Member.Network.Data.Location;
               var latitude = null;
               var longitude = null;

               var msg = "";
               var isValid = false;

               var isCurrent = ggStorage.get(ggStorage.keys.courses.location.isCurrent);
               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.location.data)) || [];

               if (isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0)) {
                  // old school callback
                  location.locate(function () {
                     if (location.isCurrent) {
                        isValid = true;
                        latitude = location.latitude;
                        longitude = location.longitude;

                        ggFunctions.toggleProcessing(true);
                        return app.Member.Network.Data.Courses.location.fetch(true, latitude, longitude).then(function (data) {
                           return processData(data);
                        }).finally(function () {
                           ggFunctions.toggleProcessing(false);
                        });
                  } else {
                        $scope.PopupAlert.warn("", location.msg);
                     }
                  });
               } else {
                  return processData(storeData);
               }
            }
            , swipe: {
               selected: 0
               , isFollowing: false
               , left: function (id) {
                  $scope.f.isSwiper();
                  $scope.Content.byLocation.swipe.selected = id;
                  $scope.Content.byLocation.swipe.isFollowing = $scope.f.isMemberCourse(id);

               }
               , right: function (memberId) {
                  $scope.f.isSwiper();
                  $scope.Content.byLocation.swipe.selected = 0;
                  $scope.Content.byLocation.swipe.isFollowing = false;
               }
               , isSelected: function (id) {
                  return id == $scope.Content.byLocation.swipe.selected
               }
            }
         }
         , refresh: function () {
            if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
               $scope.Content.byFollower.fetch(true);
            }
            if ($scope.View.tabs.current == $scope.View.tabs.types.location) {
               $scope.Content.byLocation.fetch(true);
            }
         }
         , selectCourse : function (courseId) {
         
            if (!$scope.Temp.isSwiper) {
               // close any views already open
               ngDialog.closeAll();

               // Get the Course Detail from the search results
               var results = [];
               var course = null;
               switch ($scope.View.tabs.current) {
                  case ($scope.View.tabs.types.location):
                     results = $scope.Content.byLocation.results;
                     break;
                  case ($scope.View.tabs.types.follower):
                     results = $scope.Content.byFollower.results;
                     break;
                  default:
                     results = $scope.Content.bySearch.results;
                     break;
               }

               // Get Course Information & Tees
               for (var x = 0; x < results.length; x++) {
                  if (courseId == results[x].id) {
                     course = results[x];
                  }
               }

               // Assign Course to Scorecard
               if (!course) {
                  $scope.PopupAlert.fail("Error", "The selected course was not found in the results.");
               } else {
                  $scope.Course = course;



                  ggFunctions.toggleProcessing(true);
                  ggCourseSearchSvc.search.fetchCourseDetail({ courseId: courseId }).then(function (data) {

                      if (data && data.status == 200) {
                          if (data.data && data.data.length > 0) {


                              $scope.Course = data.data[0];


                              app.Member.Session.pageTemplates.fetch(app.modules.course.routes.detail.templateUrl).then(function (template) {
                                  if (isCordova && isCordovaReady) {
                                      StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                                  }

                                  var _loginDialog = ngDialog.open({
                                      template: template
                                     , plain: true
                                     , closeByEscape: true
                                     , closeByDocument: false
                                     , className: "slideup detail course"
                                     , trapFocus: false
                                     , scope: $scope
                                  });
                                  _loginDialog.closePromise.then(function () {
                                      if (isCordova && isCordovaReady) {
                                          StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                                      }
                                  });
                              });
                          }
                     }
                  }, function (error) {
                     $scope.PopupAlert.fail("Error", "Unable to fetch course detail.");
                  }).finally(function () {
                     ggFunctions.toggleProcessing(false);
                  });

               }

            }
         
         }
      }
      
      // limiting scroll height
      angular.element($window).bind("scroll", function () {
         var windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
         var body = document.body, html = document.documentElement;
         var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
         var windowBottom = windowHeight + window.pageYOffset;
         if (windowBottom >= docHeight && !$scope.f.scrollLimit.isScrolling) {
            $scope.f.scrollLimit.scroll();
         }
      });


      $scope.f = {
         isSwiper: function () {
            $scope.Temp.isSwiper = true;
            $timeout(function () {
               $scope.Temp.isSwiper = false
            }, 1000);
         }
         , scrollLimit: {
            isScrolling : false
            , current: ggSettings.defaultScrollLimit
            , reset : function(){
               $scope.f.scrollLimit.current = ggSettings.defaultScrollLimit;
            }
               , scroll: function () {

                  $scope.f.scrollLimit.isScrolling = true;
                  $scope.$apply();
                  $timeout(function () {
                     $scope.f.scrollLimit.current = $scope.f.scrollLimit.current + ggSettings.defaultScrollLimit;
                     $scope.f.scrollLimit.isScrolling = false;
                     $scope.$apply();
                  }, 200);
               }
         }
         , isMemberCourse: function (courseId) {
            return app.Member.Network.Data.Courses.isFollowing(courseId);
         }
         , course : {
            follow : function(course){
               app.Member.Network.Data.Courses.follow(course).then(function () {
                  if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                     $scope.Content.bySearch.swipe.right(course.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
                     $scope.Content.byFollower.swipe.right(course.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.location) {
                     $scope.Content.byLocation.swipe.right(course.id);
                  }
               });
            }
            , unfollow : function(course){
               app.Member.Network.Data.Courses.unfollow(course.id).then(function (data) {
                  if ($scope.View.tabs.current == $scope.View.tabs.types.search) {
                     $scope.Content.bySearch.swipe.right(course.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.follower) {
                     $scope.Content.byFollower.swipe.right(course.id);
                  }
                  if ($scope.View.tabs.current == $scope.View.tabs.types.location) {
                     $scope.Content.byLocation.swipe.right(course.id);
                  }
               });
            }
         }
         , newOuting: function () {
            // close any views already open
            ngDialog.closeAll();
            ggFunctions.goToPage(app.modules.outing.routes.setup.path + "?courseId=" + $scope.Course.id);
         }
         , newScore: function (teeId) {
            // close any views already open
            ngDialog.closeAll();

            ggCourseSearchSvc.Course = $scope.Course;
            if (teeId) {
               ggFunctions.goToPage(app.modules.scoring.routes.postascore.path + "?courseId=" + $scope.Course.id + "&teeId="+teeId);
            } else {
               ggFunctions.goToPage(app.modules.scoring.routes.postascore.path + "?courseId=" + $scope.Course.id);
            }
         }
      }
      

      // Select inital tab.
      $scope.Content.init();

   }
}(angular, app));

